import Endpoints from 'constants/Endpoints';
import {clearResource, setResource, setSaveStatusClosed, setSaveStatusError, setSaveStatusLoading} from 'redux/actions'
import reduxStore from 'redux/store'
import {RestRequestGET, RestRequestPOST} from 'libs/RestRequest';
import isResponseValid from "../libs/isResponseValid";
import Tr from "../translations/Translations";

const PURCHASING_GROUP_TEMPLATE_RESOURCE_ID = "purchasingGroupTemplate"
const PURCHASING_GROUP_TEMPLATE_MEMBER_RESOURCE_ID = (memberId) => `purchasingGroupTemplateMember_${memberId}`;

const __get = async (url, resourcesName) => {
    try {
        let res = await RestRequestGET(url)
        if (resourcesName) {
            reduxStore.dispatch(setResource(resourcesName, res))
        }
        return res;
    } catch (error) {
    }
}

const __save = async (url, values) => {
    reduxStore.dispatch(setSaveStatusLoading());
    try {
        const resp = await RestRequestPOST(url, values)
        isResponseValid(resp, (e) => {
            throw new Error(e);
        })
        reduxStore.dispatch(setSaveStatusClosed());
        return resp;
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
    }
}


const getCollectingSchedule = async (groupId) => {
    return await __get(Endpoints.PURCHASING_GROUP_COLLECTING_SCHEDULE(groupId))
}
const saveCollectingSchedule = async (groupId, values) => {
    try {
        reduxStore.dispatch(setSaveStatusLoading());
        const resp = await RestRequestPOST(Endpoints.PURCHASING_GROUP_COLLECTING_SCHEDULE(groupId), values)
        reduxStore.dispatch(setSaveStatusClosed());
        return resp;
    } catch (e) {
    }
}

const getTemplate = async (groupId) => {
    return await __get(Endpoints.PURCHASING_GROUP_COLLECTING_TEMPLATE(groupId), PURCHASING_GROUP_TEMPLATE_RESOURCE_ID)
}
const saveTemplate = async (groupId, values) => {
    const resp = await __save(Endpoints.PURCHASING_GROUP_COLLECTING_TEMPLATE(groupId), values);
    if (resp) {
        const {resources} = reduxStore.getState();
        const newRes = {...resources[PURCHASING_GROUP_TEMPLATE_RESOURCE_ID], ...resp}
        reduxStore.dispatch(setResource(PURCHASING_GROUP_TEMPLATE_RESOURCE_ID, newRes))
    }
    return resp;

}
const getAvailableTemplates = async (groupId) => {
    reduxStore.dispatch(setSaveStatusLoading());
    const resp = await __get(Endpoints.PURCHASING_GROUP_COLLECTING_TEMPLATE_AVAILABLE(groupId))
    reduxStore.dispatch(setSaveStatusClosed());
    return resp;
}

const getTemplateMember = async (groupId, memberId) => {
    return await __get(Endpoints.PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_ID(groupId, memberId), PURCHASING_GROUP_TEMPLATE_MEMBER_RESOURCE_ID(memberId))
}

const getTemplateMemberForm = async (groupId, memberId, formId) => {
    return await __get(Endpoints.PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_FORM_ID(groupId, memberId, formId))
}

const updateReduxLists = (memberId, formId, resp) => {
    if (resp) {
        const {formListElement, formWrapper, memberListElement} = resp;
        const {resources} = reduxStore.getState();
        const curTemplate = resources[PURCHASING_GROUP_TEMPLATE_RESOURCE_ID];
        if (curTemplate) {
            const newTemplate = {...curTemplate, memberList: curTemplate.memberList.map(x => x.memberId === memberListElement.memberId ? memberListElement : x)}
            reduxStore.dispatch(setResource(PURCHASING_GROUP_TEMPLATE_RESOURCE_ID, newTemplate))
        }
        const curMember = resources[PURCHASING_GROUP_TEMPLATE_MEMBER_RESOURCE_ID(memberId)];
        if (curMember) {
            const newMember = {...curMember, formList: curMember.formList.map(x => x.formId === formListElement.formId ? formListElement : x)}
            reduxStore.dispatch(setResource(PURCHASING_GROUP_TEMPLATE_MEMBER_RESOURCE_ID(memberId), newMember))
        }
        return formWrapper;
    }
}


const saveTemplateMemberForm = async (groupId, memberId, formId, values) => {
    const resp = await __save(Endpoints.PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_FORM_ID(groupId, memberId, formId), values);
    return updateReduxLists(memberId, formId, resp);
}

const saveTemplateMemberFormDraft = async (groupId, memberId, formId, values) => {
    const resp = await __save(Endpoints.PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_FORM_ID_DRAFT(groupId, memberId, formId), values);
    return updateReduxLists(memberId, formId, resp);
}

const saveTemplateMemberFormClearDraft = async (groupId, memberId, formId) => {
    const resp = await __save(Endpoints.PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_FORM_ID_CLEAR_DRAFT(groupId, memberId, formId));
    return updateReduxLists(memberId, formId, resp);
}

const saveTemplateMemberFormAccept = async (groupId, memberId, formId) => {
    const resp = await __save(Endpoints.PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_FORM_ID_ACCEPT(groupId, memberId, formId));
    return updateReduxLists(memberId, formId, resp);
}
const saveTemplateMemberFormReject = async (groupId, memberId, formId) => {
    const resp = await __save(Endpoints.PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_FORM_ID_REJECT(groupId, memberId, formId));
    return updateReduxLists(memberId, formId, resp);
}

const saveTemplateMemberFormAskForEdit = async (groupId, memberId, formId) => {
    const resp = await __save(Endpoints.PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_FORM_ID_ASK_FOR_EDIT(groupId, memberId, formId));
    return updateReduxLists(memberId, formId, resp);
}
const saveTemplateMemberFormAllowEdit = async (groupId, memberId, formId) => {
    const resp = await __save(Endpoints.PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_FORM_ID_ALLOW_EDIT(groupId, memberId, formId));
    return updateReduxLists(memberId, formId, resp);
}
const saveTemplateMemberFormRejectEdit = async (groupId, memberId, formId) => {
    const resp = await __save(Endpoints.PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_FORM_ID_REJECT_EDIT(groupId, memberId, formId));
    return updateReduxLists(memberId, formId, resp);
}


const getArchiveList = async (groupId, memberId, formId) => {
    return await __get(Endpoints.PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_FORM_ID_ARCHIVE_LIST(groupId, memberId, formId))
}
const getArchiveElement = async (groupId, memberId, formId, archiveId) => {
    return await __get(Endpoints.PURCHASING_GROUP_COLLECTING_TEMPLATE_MEMBER_FORM_ID_ARCHIVE_ID(groupId, memberId, formId, archiveId))
}

const getFinish = async (groupId) => {
    return await __get(Endpoints.PURCHASING_GROUP_FINISH(groupId))
}
const saveFinish = async (groupId, values) => {
    return await __save(Endpoints.PURCHASING_GROUP_FINISH(groupId), values)
}
const createDemand = async (url) => {
    return await RestRequestPOST(url + "&CSRFToken=" + reduxStore.getState().resources.userData.csrf, null, {maxRedirects: 0})
}

const sendDealingsChangedNotification = async (groupId) => {
    return await RestRequestPOST(Endpoints.PURCHASING_GROUP_FINISH_DEALINGS_CHANGED(groupId));
}


const clearResources = (resourceId) => reduxStore.dispatch(clearResource(resourceId))


export default {

    //collecting schedule
    getCollectingSchedule,
    saveCollectingSchedule,

    //template
    getTemplate,
    saveTemplate,
    getAvailableTemplates,
    getTemplateMember,
    getTemplateMemberForm,
    saveTemplateMemberForm,
    saveTemplateMemberFormDraft,
    saveTemplateMemberFormClearDraft,
    saveTemplateMemberFormAccept,
    saveTemplateMemberFormReject,
    saveTemplateMemberFormAskForEdit,
    saveTemplateMemberFormAllowEdit,
    saveTemplateMemberFormRejectEdit,
    getArchiveList,
    getArchiveElement,
    getFinish,
    saveFinish,
    createDemand,

    clearResources,
    PURCHASING_GROUP_TEMPLATE_RESOURCE_ID,
    PURCHASING_GROUP_TEMPLATE_MEMBER_RESOURCE_ID,
    sendDealingsChangedNotification
}